import { call, put, takeLatest } from 'redux-saga/effects';
import * as Raven from 'raven-js';
import apiConfig from 'utils/apiConfig';
import request from 'utils/request';
import { RAVEN_LOG_LEVEL } from 'utils/constants';
import { VALIDATE_VERIFICATION_CODE } from './constants';
import { loginSuccess, setSelectedPolicyId, setSelectedClientId, setEmailAddressLogin, setPhoneNumberLogin, setIsPolicyCancelled, setFnolReportDateValidation, setError, clearError } from '../App/actions';
import { setAuthenticationToken, loading, setRequireVerificationCode, setUserName, setPolicyNumber } from '../Login/actions';
import messages from '../Login/messages';
import { startProgress, endProgress } from '../ProgressBar/actions';


function* getReportDateValidationStatus(token) {
  const requestUrl = `${apiConfig.restServiceDomain
    }/rest/validationSettings`;
  const requestOption = {
    method: 'GET',
    headers: {
      Authorization: `bearer ${token}`,
    },
  };

  return { requestUrl, requestOption };
}

export function* validateVerificationCodeSaga(action) {
  const { token, verificationCode, policyNumber, email } = action.payload;
  const requestURL = `${apiConfig.restServiceDomain}/api/v1/auth/token`;
  const options = {
    method: 'POST',
    body: JSON.stringify({ policyNumber, email }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `bearer ${token}`,
      'X-Verification-Code': verificationCode,
    },
  };
  try {
    yield put(clearError());
    Raven.captureMessage('validateVerificationCode', RAVEN_LOG_LEVEL);
    yield put(startProgress());
    yield put(loading(true));

    const response = yield call(request, requestURL, options);
    // Validate response
    if (!response || !response.token) {
      throw new Error('Invalid response: No authentication token received');
    }

    // get report date validation status
    const {
      requestUrl: reportDateValidateStatusRequest,
      requestOption: reportDateValidateStatusRequestOption,
    } = yield getReportDateValidationStatus(response.token);
    const reportDateValidationStatus = yield call(request, reportDateValidateStatusRequest, reportDateValidateStatusRequestOption);
    yield put(setFnolReportDateValidation(reportDateValidationStatus.fnolReportDateValidation));

    yield put(setAuthenticationToken(response.token));
    yield put(setSelectedPolicyId(response.policyId));
    yield put(setSelectedClientId(response.clientId));
    yield put(setUserName(response.clientName));
    yield put(setPolicyNumber(policyNumber));
    yield put(setEmailAddressLogin(response.email));
    yield put(setPhoneNumberLogin(response.phoneNumber));
    yield put(setIsPolicyCancelled(response.isPolicyCancelled));
    yield put(setRequireVerificationCode(false));
    // set token expired time
    try {
      localStorage.setItem('expiredTokenTime', (new Date().getTime() + (response.expiresIn * 1000)).toString());
    } catch (err) {
      // Handle the exception gracefully
      Raven.captureException(err);
    }
    // Set authentication state first
    // The redirectMiddleware will handle redirecting to claim-list on LOGIN_SUCCESS
    yield put(loginSuccess());
  } catch (err) {
    // Clear authentication state on failure
    // yield put(logoutSuccess());

    // Determine error message based on error type
    let errorMessage = messages.verificationCodeFail.defaultMessage;

    if (err.message && err.message.includes('Invalid response')) {
      errorMessage = 'Authentication failed: Invalid server response';
    } else if (err.status === 401) {
      errorMessage = 'Authentication failed: Invalid credentials or verification code';
    } else if (err.status === 403) {
      errorMessage = 'Authentication failed: Access denied';
    } else if (err.status === 500) {
      errorMessage = 'Authentication failed: Server error. Please try again later';
    } else if (!navigator.onLine) {
      errorMessage = 'Authentication failed: No internet connection';
    }
    yield put(setError(errorMessage));
    // Redirect to login page
    // history.push(routeConfig.login);

    Raven.captureException(err);
  } finally {
    yield put(endProgress());
    yield put(loading(false));
  }
}

export default function* loginVerificationSaga() {
  yield takeLatest(VALIDATE_VERIFICATION_CODE, validateVerificationCodeSaga);
}



// WEBPACK FOOTER //
// ./app/containers/App/saga.js